import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutRowDirective } from './layout-row.directive';


@NgModule({
    declarations: [LayoutRowDirective],
    imports: [
        CommonModule
    ],
    exports: [
        LayoutRowDirective
    ]
})
export class LayoutRowModule {}
